import React from "react";
import { Navigation, Link } from "react-router";
import Api from "js/utilities/fnapi-client";
import { ZOOM_ICON } from "js/config.jsx";
import AppHeader from "js/components/elements/sdk-header";
import Validate from "js/utilities/validate";
import NoHal, {halCheck} from "js/utilities/no-hal";
import Loader from "react-loader";
export default React.createClass({
  mixins: [Navigation],

  statics: {
    includeHeaderFooter: false
  },

  getInitialState: function() {
    return {
      error: null,
      loading: false
    };
  },

  render: function() {
    return (
        <div className="bg">
          <div className="signin">
            <div className="box">
              <div className="header">
                <img src={ZOOM_ICON} className="img"/>
                <p className="title">developer account</p>
              </div>
              <p className="sub-title">recovery</p>
              <form autoComplete="off" onSubmit={this.handleSubmit}>
                <input id="input-email" ref="email" placeholder="email address" type="email" required autoFocus />
                <br></br>
                <div className="password-button">
                  <button type="submit" className="mobile-fix">
                    <a id="fontstack">{!this.state.loading ? "send recovery email" : <Loader loaded={this.state.loaded} lines={12} length={2.5} width={2.5} radius={10} corners={1} rotate={0} direction={1} speed={1.75} trail={80} shadow={false} hwaccel={true} className="spinner" zIndex={2e9} top="50%" left="50%" scale={.8}></Loader> }</a>
                  </button>
                </div>
                <p className="loginerror">{this.state.error}</p>
                <a className="back-button" onClick={this.props.history.goBack}>go back</a>
                <NoHal/>
              </form>
            </div>
          </div>
        </div>
    );
  },

  handleSubmit: function(event) {
    event.preventDefault();
    var data = {
      email: this.refs.email.value
    };
    if (halCheck(data.email, this)) {
      return
    }
    if (!Validate.email(data.email)) {
      this.setState({error: "Please enter a valid email address", loading:false})
      return
    }
    else {
      this.setState({
        error: null,
        loading: true,
        loaded: false
      });
  }
    Api.post("user/password/request", data).then( (response) => {
      this.setState({loading: false});
      this.setState({error: "Please check your email for a message with instructions on resetting your password."});
    }).catch( (error) => {
      return this.setState({loading: false, error: error.message});
    });
  }
});



// WEBPACK FOOTER //
// ./src/js/components/screens/recover-password.jsx